module.exports = __webpack_public_path__ + "static/media/snapshot1.09881eeb.png";